window.$ = window.jQuery = require("jquery");
const { jrNotifyError, jrLeaveBreadcrumb } = require("../bootstrap");
require("./validation");
require("./cart-manager");
const { $err } = require("./error-manager");

export function BraintreeManager(cartManager, clientToken, config) {
    var self = this;
    self.cm = cartManager;
    self.config = $.extend(
        true,
        {
            errorContainer: ".error-container",
            PhoneOrderNonce: "not-supported",
            DataCollector: {
                formSelector: null
            },
            HostedFields: {
                btnSelector: ".btn-checkout",
                formSelector: null
            },
            Paypal: {
                btnContainer: ".paypal-btn-container",
                btnSelector: ".btn-paypal",
                purchaseUrl: null,
                purchaseBegin: null,
                purchaseSuccess: null,
                purchaseFailure: null
            },
            /*
            ApplePay: {
                btnContainer: ".applepay-btn-container",
                btnSelector: ".apple-pay-button",
                purchaseUrl: null,
                purchaseBegin: null,
                purchaseSuccess: null,
                purchaseFailure: null
            },
             */
            VisaCheckout: {
                btnContainer: ".visacheckout-btn-container",
                btnSelector: ".visacheckout-button",
                purchaseUrl: null,
                purchaseBegin: null,
                purchaseSuccess: null,
                purchaseFailure: null
            }
        },
        config
    );

    function displayError(error) {
        $err.displayErrors([error], self.config.errorContainer);
    }

    function reportError(type, errorMsg, meta) {
        jrNotifyError(
            type + ": " + errorMsg,
            $.extend(
                true,
                {
                    orderID: self.cm.cart.orderID
                },
                meta
            )
        );
    }

    function reportBraintreeError(errorMsg, braintreeError) {
        reportError("BraintreeError", errorMsg, braintreeError);
    }

    function handleError(errorMsg, meta) {
        reportError("CheckoutError", errorMsg, meta);
        displayError({ message: errorMsg });
    }

    function handleBraintreeError(errorMsg, braintreeError) {
        // braintreeError = {code: '', details: '', message: '', type: ''}
        reportBraintreeError(errorMsg, braintreeError);
        displayError({
            title: errorMsg,
            message: braintreeError.message,
            details: braintreeError.details
        });
    }

    function leaveBreadcrumb(msg, meta) {
        jrLeaveBreadcrumb(
            msg,
            $.extend(
                true,
                {
                    orderID: self.cm.cart.orderID
                },
                meta
            )
        );
    }

    // Create BT client instance immediately
    window.braintree.client.create(
        {
            authorization: clientToken
        },
        function(clientErr, clientInstance) {
            if (clientErr) {
                reportBraintreeError("Payment initialization error", clientErr);
                return;
            }

            if (self.config.DataCollector.formSelector) {
                self.createDataCollector(clientInstance, self.config.DataCollector);
            }

            if (self.config.HostedFields.formSelector) {
                self.createHostedFields(clientInstance, self.config.HostedFields);
            }

            if (self.config.Paypal.purchaseUrl) {
                self.createPaypal(clientInstance, self.config.Paypal);
            }

            if (self.config.VisaCheckout.purchaseUrl) {
                self.createVisaCheckout(clientInstance, self.config.VisaCheckout);
            }

            /*
            if (self.config.ApplePay.purchaseUrl) {
                if (window.ApplePaySession && window.ApplePaySession.canMakePayments()) {
                    self.createApplePay(clientInstance, self.config.ApplePay);
                } else if (!window.ApplePaySession) {
                    leaveBreadcrumb("Apple Pay", {
                        message: "This device does not support Apple Pay"
                    });
                } else if (!window.ApplePaySession.canMakePayments()) {
                    leaveBreadcrumb("Apple Pay", {
                        message: "This device is not capable of making Apple Pay payments"
                    });
                }
            }
             */
        }
    );

    // Create hosted fields
    self.createDataCollector = function(clientInstance, dataCollectorConfig) {
        leaveBreadcrumb("Create Data Collector");
        window.braintree.dataCollector.create(
            {
                client: clientInstance,
                kount: true
            },
            function(dataCollectorErr, dataCollectorInstance) {
                if (dataCollectorErr) {
                    // reportBraintreeError('Error initializing data collector', dataCollectorErr);
                    return;
                }

                var form = $(dataCollectorConfig.formSelector)[0];
                var deviceDataInput = form["device_data"];

                if (deviceDataInput == null) {
                    deviceDataInput = document.createElement("input");
                    deviceDataInput.name = "device_data";
                    deviceDataInput.type = "hidden";
                    form.appendChild(deviceDataInput);
                }

                deviceDataInput.value = dataCollectorInstance.deviceData;
            }
        );
    };

    // Create hosted fields
    self.createHostedFields = function(clientInstance, hostedFieldsConfig) {
        leaveBreadcrumb("Create Hosted Fields");
        window.braintree.hostedFields.create(
            {
                client: clientInstance,
                styles: {
                    input: {
                        color: "#282c37",
                        "font-size": "16px",
                        transition: "color 0.1s",
                        "line-height": "1"
                    },
                    // Style the text of an invalid input
                    "input.invalid": {
                        color: "#E53A40"
                    },
                    // placeholder styles need to be individually adjusted
                    "::-webkit-input-placeholder": {
                        color: "#bbb"
                    },
                    ":-moz-placeholder": {
                        color: "#bbb"
                    },
                    "::-moz-placeholder": {
                        color: "#bbb"
                    },
                    ":-ms-input-placeholder": {
                        color: "#bbb"
                    }
                },
                fields: {
                    number: {
                        selector: "#card-number",
                        placeholder: "Card number"
                    },
                    cvv: {
                        selector: "#cvv",
                        placeholder: "###"
                    },
                    expirationDate: {
                        selector: "#expiration-date",
                        placeholder: "mm/yyyy"
                    }
                }
            },
            function(hostedFieldsErr, hostedFieldsInstance) {
                if (hostedFieldsErr) {
                    handleBraintreeError(
                        "Error initializing credit card checkout",
                        hostedFieldsErr
                    );
                    return;
                }

                hostedFieldsInstance.on("validityChange", function(event) {
                    // Check if all fields are valid, then show submit button
                    var formValid = Object.keys(event.fields).every(function(key) {
                        return event.fields[key].isValid;
                    });

                    if (formValid) {
                        $(hostedFieldsConfig.btnSelector).removeAttr("disabled");
                    } else {
                        $(hostedFieldsConfig.btnSelector).attr("disabled", "disabled");
                    }
                });

                hostedFieldsInstance.on("inputSubmitRequest", function() {
                    $(hostedFieldsConfig.btnSelector).click();
                });

                hostedFieldsInstance.on("empty", function(event) {
                    if (event.cards.length !== 1 || event.emittedBy == "number") {
                        $("header").removeClass("header-slide");
                        $("#card-image").removeClass();
                        $("#card-input").removeClass();
                    }
                });

                hostedFieldsInstance.on("cardTypeChange", function(event) {
                    // Change card bg depending on card type
                    if (event.cards.length === 1) {
                        $("#card-input")
                            .removeClass()
                            .addClass(event.cards[0].type);
                        $("#card-image")
                            .removeClass()
                            .addClass(event.cards[0].type);
                        $("header").addClass("header-slide");

                        // Change the CVV length for AmericanExpress cards
                        if (event.cards[0].code.size === 4) {
                            hostedFieldsInstance.setPlaceholder("cvv", "####");
                        }
                    } else {
                        hostedFieldsInstance.setPlaceholder("cvv", "###");
                    }
                });

                $(hostedFieldsConfig.formSelector).validate({
                    submitHandler: function(form) {
                        if ($('input[name="nonce"]').val() == self.config.PhoneOrderNonce) {
                            $('input[name="nonce"]').val(null);
                            form.submit();
                        } else {
                            leaveBreadcrumb("Tokenize Hosted Fields");
                            hostedFieldsInstance.tokenize(function(tokenizeErr, payload) {
                                if (tokenizeErr) {
                                    handleBraintreeError(
                                        "Credit card tokenization failed",
                                        tokenizeErr
                                    );
                                    return;
                                }

                                $('input[name="nonce"]').val(payload.nonce);
                                form.submit();
                            });
                        }
                    },
                    rules: {
                        countryID: {
                            required: true
                        },
                        firstname: {
                            required: true,
                            maxlength: 50
                        },
                        lastname: {
                            required: true,
                            maxlength: 50
                        },
                        company: {
                            maxlength: 50
                        },
                        address1: {
                            required: true,
                            maxlength: 29
                        },
                        address2: {
                            maxlength: 29
                        },
                        city: {
                            required: true,
                            maxlength: 50
                        },
                        stateID: {
                            required: true
                        },
                        province: {
                            maxlength: 50
                        },
                        zip: {
                            required: function(/* element */) {
                                return (
                                    $(
                                        hostedFieldsConfig.formSelector +
                                            ' select[name="countryID"]'
                                    ).val() == "1"
                                );
                            },
                            maxlength: 10
                        }
                    }
                });
            }
        );
    };

    // Create a PayPal component.
    self.createPaypal = function(clientInstance, paypalConfig) {
        leaveBreadcrumb("Create Paypal");
        window.braintree.paypal.create(
            {
                client: clientInstance
            },
            function(paypalErr, paypalInstance) {
                if (paypalErr) {
                    // Report only
                    reportError("BraintreeError", "Error initializing PayPal", paypalErr);
                    return;
                }

                // Setup the button handler
                $(paypalConfig.btnContainer).show();
                $(paypalConfig.btnSelector).click(function() {
                    leaveBreadcrumb("Tokenize Paypal");
                    paypalInstance.tokenize(
                        $.extend(
                            {
                                flow: "checkout",
                                intent: "authorize",
                                useraction: "commit",
                                locale: "en_US",
                                enableShippingAddress: true
                            },
                            self.paypalTotal()
                        ),
                        function(tokenizeErr, payload) {
                            if (tokenizeErr) {
                                switch (tokenizeErr.code) {
                                    case "PAYPAL_FLOW_FAILED":
                                        handleBraintreeError(
                                            "Error initializing PayPal flow",
                                            tokenizeErr
                                        );
                                        break;
                                    default:
                                        if (tokenizeErr.type !== "CUSTOMER") {
                                            handleBraintreeError(
                                                "PayPal tokenization failed",
                                                tokenizeErr
                                            );
                                        }
                                }
                                return;
                            }

                            self.completePurchase(paypalConfig, {
                                nonce: payload.nonce,
                                details: payload.details
                            });
                        }
                    );
                });
            }
        );
    };

    // Create a VisaCheckout component.
    self.createVisaCheckout = function(clientInstance, visaCheckoutConfig) {
        leaveBreadcrumb("Create Visa Checkout");
        window.braintree.visaCheckout.create(
            {
                client: clientInstance
            },
            function(visaCheckoutErr, visaCheckoutInstance) {
                if (visaCheckoutErr) {
                    // Report only
                    reportError(
                        "BraintreeError",
                        "Error initializing VisaCheckout",
                        visaCheckoutErr
                    );
                    return;
                }

                // Setup the button handler
                $(visaCheckoutConfig.btnContainer).show();

                var visaInit = function(cart) {
                    var initOptions = visaCheckoutInstance.createInitOptions(
                        self.visaCheckoutTotal(cart)
                    );
                    leaveBreadcrumb("V.init");
                    window.V.init(initOptions);
                };
                visaInit(self.cm.cart);
                self.cm.registerCallback(visaInit);

                window.V.on("payment.success", function(payment) {
                    leaveBreadcrumb("Tokenize Visa Checkout");
                    visaCheckoutInstance.tokenize(payment, function(tokenizeErr, payload) {
                        if (tokenizeErr) {
                            handleBraintreeError("Visa Checkout tokenization failed", tokenizeErr);
                        } else {
                            self.completePurchase(visaCheckoutConfig, {
                                nonce: payload.nonce,
                                details: payload
                            });
                        }
                    });
                });
            }
        );
    };

    // Create an ApplePay component.
    /*
    self.createApplePay = function(clientInstance, applePayConfig) {
        leaveBreadcrumb("Create Apple Pay");
        window.braintree.applePay.create(
            {
                client: clientInstance
            },
            function(applePayErr, applePayInstance) {
                if (applePayErr) {
                    reportBraintreeError("Error initializing Apple Pay checkout", applePayErr);
                    return;
                }

                $(applePayConfig.btnContainer).show();
                $(applePayConfig.btnSelector).click(function() {
                    if (applePayConfig.prepareCallback && !applePayConfig.prepareCallback()) {
                        return false;
                    }

                    var paymentRequest = applePayInstance.createPaymentRequest({
                        total: self.applePayTotal(),
                        lineItems: self.applePayLineItems(),
                        shippingMethods: self.applePayShippingMethods(),
                        requiredBillingContactFields: ["name"],
                        requiredShippingContactFields: ["postalAddress", "name", "phone", "email"]
                    });

                    var session = new window.ApplePaySession(1, paymentRequest);

                    session.onshippingmethodselected = function(event) {
                        self.cm.setShipMethod(
                            event.shippingMethod.identifier,
                            null,
                            function() {
                                session.completeShippingMethodSelection(
                                    window.ApplePaySession.STATUS_SUCCESS,
                                    self.applePayTotal(),
                                    self.applePayLineItems()
                                );
                            },
                            function() {
                                handleError("Error selecting ship method");
                                session.completeShippingMethodSelection(
                                    window.ApplePaySession.STATUS_FAILURE,
                                    null,
                                    null
                                );
                            }
                        );
                    };

                    session.onshippingcontactselected = function(event) {
                        if (event.shippingContact.countryCode) {
                            self.cm.setShipCountryCode(
                                event.shippingContact.countryCode,
                                function() {
                                    session.completeShippingContactSelection(
                                        window.ApplePaySession.STATUS_SUCCESS,
                                        self.applePayShippingMethods(),
                                        self.applePayTotal(),
                                        self.applePayLineItems()
                                    );
                                },
                                function() {
                                    handleError("Error selecting ship country");
                                    session.completeShippingContactSelection(
                                        window.ApplePaySession.STATUS_FAILURE,
                                        self.applePayShippingMethods(),
                                        self.applePayTotal(),
                                        self.applePayLineItems()
                                    );
                                }
                            );
                        }
                    };

                    session.onvalidatemerchant = function(event) {
                        applePayInstance.performValidation(
                            {
                                validationURL: event.validationURL,
                                displayName: "Julianna Rae"
                            },
                            function(validationErr, merchantSession) {
                                if (validationErr) {
                                    handleBraintreeError(
                                        "Apple Pay failed to load.",
                                        validationErr
                                    );
                                    session.abort();
                                    return;
                                }
                                session.completeMerchantValidation(merchantSession);
                            }
                        );
                    };

                    session.onpaymentauthorized = function(event) {
                        leaveBreadcrumb("Tokenize Apple Pay");
                        applePayInstance.tokenize(
                            {
                                token: event.payment.token
                            },
                            function(tokenizeErr, payload) {
                                if (tokenizeErr) {
                                    handleBraintreeError(
                                        "Apple Pay tokenization failed",
                                        tokenizeErr
                                    );
                                    session.completePayment(window.ApplePaySession.STATUS_FAILURE);
                                    return;
                                }
                                session.completePayment(window.ApplePaySession.STATUS_SUCCESS);

                                self.completePurchase(applePayConfig, {
                                    nonce: payload.nonce,
                                    details: event.payment
                                });
                            }
                        );
                    };

                    session.begin();
                });
            }
        );
    };
    */

    self.paypalTotal = function() {
        var cart = self.cm.cart;
        return {
            amount: cart.finaltotal.toFixed(2),
            currency: "USD"
        };
    };

    self.visaCheckoutTotal = function(cart) {
        var paymentRequest = {
            currencyCode: "USD",
            subtotal: cart.subtotal.toFixed(2).toString(),
            total: cart.finaltotal.toFixed(2).toString(),
            orderId: cart.orderID.toString()
        };
        if (cart.shipcharge) {
            paymentRequest.shippingHandling = cart.shipcharge.toFixed(2).toString();
        }
        if (cart.giftwrapcharge) {
            paymentRequest.giftWrap = cart.giftwrapcharge.toFixed(2).toString();
        }
        if (cart.promotionDiscount) {
            paymentRequest.discount = cart.promotionDiscount.toFixed(2).toString();
        }
        if (cart.promotion) {
            paymentRequest.promoCode = cart.promotion;
        }
        return {
            settings: {
                displayName: "Julianna Rae",
                logoUrl: "https://d3qljwrs1kgk0n.cloudfront.net/web/inverse_logo_120px.png",
                websiteUrl: "https://www.juliannarae.com",
                review: {
                    buttonAction: "Pay"
                }
            },
            paymentRequest: paymentRequest
        };
    };

    /*
    self.applePayShippingMethods = function() {
        var cart = self.cm.cart;
        var methods = $.map(cart.shipmethods, function(method) {
            if (!method.scheduled) {
                return {
                    label: method.name,
                    detail: method.detail,
                    amount: method.amount.toFixed(2),
                    identifier: method.shipmethodID
                };
            }
        });
        // Sort so selected method is first
        methods.sort(function(a, b) {
            if (a.identifier == cart.shipmethodID) {
                return -1;
            }
            if (b.identifier == cart.shipmethodID) {
                return 1;
            }
            var aVal = parseFloat(a.amount);
            var bVal = parseFloat(b.amount);
            return aVal < bVal ? -1 : aVal > bVal ? 1 : 0;
        });
        return methods;
    };

    self.applePayTotal = function() {
        var cart = self.cm.cart;
        return {
            label: "Julianna Rae, Inc",
            type: "final",
            amount: cart.finaltotal.toFixed(2)
        };
    };

    self.applePayLineItems = function() {
        var cart = self.cm.cart;
        var items = [
            {
                label: "Subtotal",
                type: "final",
                amount: cart.subtotal.toFixed(2)
            },
            {
                label: "Shipping",
                type: "final",
                amount: (cart.shipcharge - cart.discountShipping).toFixed(2)
            }
        ];
        if (cart.giftwrapcharge > 0) {
            items.push({
                label: "Giftwrap",
                type: "final",
                amount: (cart.giftwrapcharge - cart.discountGiftwrap).toFixed(2)
            });
        }
        if (cart.tax > 0) {
            items.push({
                label: "Tax",
                type: "final",
                amount: cart.tax.toFixed(2)
            });
        }
        if (cart.promotiondiscount > 0) {
            items.push({
                label: "Discount",
                type: "final",
                amount: (cart.promotiondiscount * -1).toFixed(2)
            });
        }
        if (cart.giftcardamountapplied > 0) {
            items.push({
                label: "Gift Card",
                type: "final",
                amount: (cart.giftcardamountapplied * -1).toFixed(2)
            });
        }
        if (cart.storecreditapplied > 0) {
            items.push({
                label: "Store Credit",
                type: "final",
                amount: (cart.storecreditapplied * -1).toFixed(2)
            });
        }
        return items;
    };
    */

    self.completePurchase = function(providerConfig, data) {
        $(self.config.errorContainer).empty();
        if (providerConfig.purchaseBegin) {
            providerConfig.purchaseBegin(data);
        }
        leaveBreadcrumb("Attempting Purchase", data);
        $.ajax({
            dataType: "json",
            url: providerConfig.purchaseUrl.replace("orderID", self.cm.cart.orderID),
            method: "POST",
            data: data,
            success: function(res) {
                if (providerConfig.purchaseSuccess) {
                    providerConfig.purchaseSuccess(res);
                }
                // Navigate to receipt
                window.location.href = res.data.route;
            },
            error: function(err) {
                if (providerConfig.purchaseFailure) {
                    providerConfig.purchaseFailure(err);
                }
                jrNotifyError(
                    "PurchaseError: Could not complete purchase",
                    $.extend(
                        true,
                        {
                            orderID: self.cm.cart.orderID
                        },
                        err ? err.responseJSON : null
                    )
                );
                $err.ajaxError(err, self.config.errorContainer);
                self.cm.refreshCart();
            }
        });
    };
}
